<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">Cover Design: <a href="http://www.written-ink.com" target="_blank"><span class="t4">Written Ink Designs</span></a> | written-ink.com</p>
<p class="p1">Image(s) used under a Standard Royalty-Free License.</p>
<p class="p1">All rights reserved.</p>
<p class="p2"> </p>
<p class="p2">WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.</p>
<p class="p2">No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.</p>
<p class="p2">This book is for ADULT AUDIENCES ONLY. It may contain sexually explicit scenes and graphic language which might be considered offensive by some readers. Please store your files where they cannot be accessed by minors.</p>
<p class="p2">This is a work of fiction. Names, characters, places, and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.</p>
<p class="p2">Published in the United States of America.</p>
<p class="p3">* * * *</p>
<p class="p2">Gabi Cervenka and Leonie Duncan, thank you for everything you do.</p>
<p class="p2"><span class="t5">Vampire’s Delight</span> celebrates National Coffee with a Cop Day, which is observed annually on the first Wednesday in October. The day has been around since 2011, and its mission is to build a healthy relationship between civilians and police officers. So we have cops and coffee in this one, but we also have vampires, shifters, and blood witches!</p>
<p class="p0"><span class="t1"> </span></p>
<p class="p0"><span class="t1"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?50b2a2d9